export default __webpack_public_path__ + "static/media/letter-video.768c50b5.png";